export default [
  {
    value: 1,
    text: "30000",
  },
  {
    value: 2,
    text: "15000",
  },
  {
    value: 3,
    text: "10000",
  },
  {
    value: 4,
    text: "8000",
  }
]